export default {
  user: null
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/user/state.js
// module id = null
// module chunks = 